/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum WorkoutCategory {
    FOOT = 'FOOT',
    WHEELS = 'WHEELS',
    WATER = 'WATER',
    WINTER = 'WINTER',
    TEAM_SPORTS = 'TEAM_SPORTS',
    STATIONARY_TRAININGS = 'STATIONARY_TRAININGS',
    OTHER = 'OTHER'
}

export interface WorkoutTypeRuleUpdateRequestDto {
    workoutType?: WorkoutTypeV2;
    workoutCategory?: WorkoutCategory;
    validationRule: WorkoutValidationRuleDto;
}

export enum WorkoutTypeV2 {
    RUNNING = 'RUNNING',
    WALKING = 'WALKING',
    TREKKING = 'TREKKING',
    HIKING = 'HIKING',
    TREADMILL = 'TREADMILL',
    NORDIC_WALKING = 'NORDIC_WALKING',
    CYCLING = 'CYCLING',
    ELECTRIC_CYCLING = 'ELECTRIC_CYCLING',
    INDOOR_CYCLING = 'INDOOR_CYCLING',
    ROLLERBLADE = 'ROLLERBLADE',
    SKATEBOARD = 'SKATEBOARD',
    SCOOTER = 'SCOOTER',
    WHEELCHAIR = 'WHEELCHAIR',
    SKIING = 'SKIING',
    SNOWBOARDING = 'SNOWBOARDING',
    SKATING = 'SKATING',
    SKI_TOURING = 'SKI_TOURING',
    CROSS_COUNTRY_SKIING = 'CROSS_COUNTRY_SKIING',
    BIATHLON = 'BIATHLON',
    SWIMMING = 'SWIMMING',
    ROWING = 'ROWING',
    SURFING = 'SURFING',
    SAILING = 'SAILING',
    STAND_UP_PADDLE = 'STAND_UP_PADDLE',
    FOOTBALL = 'FOOTBALL',
    VOLLEYBALL = 'VOLLEYBALL',
    BASKETBALL = 'BASKETBALL',
    HANDBALL = 'HANDBALL',
    TRAINING = 'TRAINING',
    DANCING = 'DANCING',
    MARTIAL_ARTS = 'MARTIAL_ARTS',
    TENNIS = 'TENNIS',
    SQUASH = 'SQUASH',
    PADEL = 'PADEL',
    TABLE_TENNIS = 'TABLE_TENNIS',
    BADMINTON = 'BADMINTON',
    CLIMBING = 'CLIMBING',
    TREADMILL_TIME = 'TREADMILL_TIME',
    SWIMMING_TIME = 'SWIMMING_TIME',
    INDOOR_WALKING_TIME = 'INDOOR_WALKING_TIME',
    INDOOR_RUNNING_TIME = 'INDOOR_RUNNING_TIME',
    INDOOR_CYCLING_TIME = 'INDOOR_CYCLING_TIME',
    INDOOR_ROWING_TIME = 'INDOOR_ROWING_TIME',
    ELLIPTICAL = 'ELLIPTICAL',
    STRENGTH = 'STRENGTH',
    HIIT = 'HIIT',
    CARDIO = 'CARDIO',
    CROSSFIT = 'CROSSFIT',
    YOGA = 'YOGA',
    PILATES = 'PILATES',
    STRETCHING = 'STRETCHING',
    AEROBIC = 'AEROBIC',
    ZUMBA = 'ZUMBA',
    AQUA_GYM = 'AQUA_GYM',
    GOLF = 'GOLF',
    HORSE_RIDING = 'HORSE_RIDING',
    OTHER = 'OTHER'
}

export interface WorkoutValidationRuleDto {
    /** @format double */
    minAverageSpeed?: number;
    /** @format double */
    maxAverageSpeed?: number;
    /** @format double */
    maxAllowedSpeed?: number;
    /** @format int64 */
    minDurationInMinutes?: number;
    /** @format int64 */
    minDistanceInMeters?: number;
    /** @format int64 */
    maxDistanceInMeters?: number;
    /** @format double */
    minCaloriesPerMinute?: number;
}

export interface WorkoutTypeRuleDto {
    /** @format int64 */
    id: number;
    workoutType?: WorkoutTypeV2;
    workoutCategory?: WorkoutCategory;
    validationRule: WorkoutValidationRuleDto;
}

export interface WorkoutTypeMappingUpdateRequestDto {
    /** @minLength 1 */
    rawType: string;
    workoutType?: WorkoutTypeV2;
    rejected?: boolean;
}

export interface WorkoutTypeMappingDto {
    rawType: string;
    workoutType?: WorkoutTypeV2;
    rejected: boolean;
}

export interface WorkoutTypeMappingBatchUpdateResponseDto {
    /** @format int32 */
    created: number;
    /** @format int32 */
    updated: number;
}

export interface WorkoutRuleDto {
    /** @format int64 */
    minWorkoutDurationMinutes: number;
    /**
     * @format double
     * @min 0
     */
    minAverageSpeed: number;
    /**
     * @format double
     * @exclusiveMin 0
     */
    maxAverageSpeed: number;
    /**
     * @format double
     * @exclusiveMin 0
     */
    maxAllowedSpeed: number;
    /**
     * @format int64
     * @exclusiveMin 0
     */
    minStudioVisitDurationMinutes: number;
    /**
     * @format int64
     * @exclusiveMin 0
     */
    noRecentCheckInConfirmationNotificationTimeoutMinutes: number;
    /**
     * @format int64
     * @exclusiveMin 0
     */
    minConfirmationsAwayToCheckOut: number;
    /** @format int64 */
    minDurationAwayToCheckOutMinutes: number;
    /**
     * @format double
     * @exclusiveMin 0
     */
    distanceCheckOutThreshold: number;
    /** @format int64 */
    checkInTimeoutMinutes: number;
}

export interface UserFlagDto {
    /** @format int64 */
    id: number;
    userId: string;
    status: WorkoutFlagStatus;
    comment: string;
    createdBy: string;
    activityIds: number[];
}

export enum WorkoutFlagStatus {
    SUSPICIOUS = 'SUSPICIOUS',
    FRAUD = 'FRAUD',
    NOT_FRAUD = 'NOT_FRAUD'
}

export enum CompositePointSourceType {
    ACTIVITY_POINTS = 'ACTIVITY_POINTS',
    REWARD_CURRENCY = 'REWARD_CURRENCY'
}

export interface CreateCompositePointSourceRuleRequestDto {
    sourceType: CompositePointSourceType;
    sourceKey?: string;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    /**
     * @minLength 0
     * @maxLength 256
     */
    expression: string;
    /** @format int32 */
    priority: number;
    enabled: boolean;
}

export interface UpdateCompositePointDefinitionRequestDto {
    pointTypeKey?: string;
    /**
     * @minLength 0
     * @maxLength 255
     */
    label?: string;
    /**
     * @minLength 0
     * @maxLength 10000
     */
    symbolSvg?: string;
    enabled?: boolean;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    /**
     * @maxItems 2147483647
     * @minItems 1
     */
    sourceRules?: any[];
}

export interface CompositePointDefinitionDto {
    /** @format int64 */
    id: number;
    /** @format int64 */
    communityId: number;
    pointTypeKey: string;
    label: string;
    symbolSvg?: string;
    enabled: boolean;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    sourceRules: CompositePointSourceRuleDto[];
}

export interface CompositePointSourceRuleDto {
    /** @format int64 */
    id: number;
    sourceType: CompositePointSourceType;
    sourceKey?: string;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    expression: string;
    /** @format int32 */
    priority: number;
    enabled: boolean;
}

export enum ActivityType {
    DAILY_STEPS = 'DAILY_STEPS',
    FACILITY_VISIT = 'FACILITY_VISIT',
    WORKOUT = 'WORKOUT'
}

export interface CommunityGoalUpdateRequestDto {
    rule: GoalRuleDto;
    timeZone: string;
    /** @format int64 */
    communityId: number;
    rewardValue?: number;
}

export interface GoalActivityFilterDto {
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    hasArrivalLocation?: boolean;
    minRawValue?: number;
    fitnessMetricType?: GoalFitnessMetricType;
}

export enum GoalAggregationType {
    SUM = 'SUM',
    MAX = 'MAX'
}

export enum GoalFitnessMetricType {
    DISTANCE = 'DISTANCE',
    ACTIVITY_TIME_IN_MINUTES = 'ACTIVITY_TIME_IN_MINUTES',
    STEPS = 'STEPS',
    CALORIES = 'CALORIES'
}

export interface GoalRuleDto {
    type: GoalRuleType;
    /**
     * @format int32
     * @exclusiveMin 0
     */
    value: number;
    levels?: any[];
    fitnessMetricType?: GoalFitnessMetricType;
    aggregationType?: GoalAggregationType;
    /**
     * Use activityFilters instead
     * @deprecated
     */
    activityType?: ActivityType;
    /**
     * Use activityFilters instead
     * @deprecated
     */
    workoutCategory?: WorkoutCategory;
    /**
     * Use activityFilters instead
     * @deprecated
     */
    workoutType?: WorkoutTypeV2;
    socialMetricType?: GoalSocialMetricType;
    activityFilters?: any[];
}

export interface GoalRuleLevelDto {
    /**
     * @format int32
     * @exclusiveMin 0
     */
    levelIndex: number;
    /**
     * @format int32
     * @exclusiveMin 0
     */
    threshold: number;
}

export enum GoalRuleType {
    ACTIVITY_POINTS = 'ACTIVITY_POINTS',
    ACTIVITY_RAW_VALUE = 'ACTIVITY_RAW_VALUE',
    ACTIVITY_COUNT = 'ACTIVITY_COUNT',
    SOCIAL = 'SOCIAL'
}

export enum GoalSocialMetricType {
    POSTS = 'POSTS',
    LIKES = 'LIKES',
    FOLLOWERS = 'FOLLOWERS'
}

export enum BadgeCategory {
    DEFAULT = 'DEFAULT',
    FAMILY = 'FAMILY'
}

export interface BadgeDto {
    /** @format int64 */
    id: number;
    badgeType: BadgeType;
    badgeCategory: BadgeCategory;
    /** @format int32 */
    thresholdValue: number;
    image: CdnObjectDto;
}

export interface BadgeLevelDto {
    /** @format int64 */
    id: number;
    /** @format int64 */
    badgeTypeId: number;
    /** @format int32 */
    levelIndex: number;
    name: Record<string, string>;
    description?: object;
    image?: CdnObjectDto;
    threshold: number;
}

export enum BadgeType {
    GOAL_STREAK = 'GOAL_STREAK'
}

export interface CdnObjectDto {
    /** @minLength 1 */
    bucket: string;
    /** @minLength 1 */
    key: string;
}

export enum DayOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}

export interface GoalDto {
    /** @format int64 */
    id: number;
    key: string;
    type: GoalOwnerType;
    rule: GoalRuleDto;
    /**
     * Moved to rule
     * @deprecated
     * @format int32
     */
    value?: number;
    recurrence: RecurrenceType;
    owner: GoalOwnerDto;
    rewardConfigs: RewardConfigDto[];
    streakEnabled?: boolean;
    badges: BadgeDto[];
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
    autoAssignEnabled: boolean;
    visibleInApp: boolean;
    name?: string;
    /** @format duration */
    rewardingDuration?: string;
}

export interface GoalOwnerDto {
    /** @format int64 */
    communityId?: number;
    userId?: string;
    tenantId?: string;
    /** @minLength 1 */
    name: string;
    image?: CdnObjectDto;
}

export enum GoalOwnerType {
    PERSONAL = 'PERSONAL',
    COMMUNITY = 'COMMUNITY',
    TENANT = 'TENANT',
    SYSTEM = 'SYSTEM'
}

export enum RecurrenceType {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    LIFETIME = 'LIFETIME'
}

export interface RewardConfigDto {
    rewardingType: RewardingType;
    /** @min 0 */
    value?: number;
    currencyCode?: string;
    /**
     * Use limit instead
     * @deprecated
     * @format int32
     */
    maxRewards?: number;
    /** @format int32 */
    minStreakValue?: number;
    /** @format int32 */
    minLevelValue?: number;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
    filterDayOfWeek?: DayOfWeek;
    limit?: RewardLimitDto;
    /** @format int64 */
    badgeLevelId?: number;
    badgeLevel?: BadgeLevelDto;
}

export interface RewardLimitDto {
    /**
     * @format int32
     * @exclusiveMin 0
     */
    maxRewards: number;
    maxRewardsPeriod: RecurrenceType;
}

export enum RewardingType {
    GOAL_REACHED = 'GOAL_REACHED',
    STREAK_INCREASED = 'STREAK_INCREASED',
    LEVEL_INCREASED = 'LEVEL_INCREASED'
}

export type BestEffortParameters = WorkoutCalculatedMetricParameters & {
    /**
     * @format double
     * @exclusiveMin 0
     */
    distanceMeters?: number;
};

export interface UpdateWorkoutCalculatedMetricDefinitionRequestDto {
    /** @minLength 1 */
    label: string;
    parameters: BestEffortParameters;
    /**
     * @minItems 1
     * @uniqueItems true
     */
    workoutTypes: WorkoutTypeV2[];
    enabled: boolean;
}

export interface WorkoutCalculatedMetricParameters {
    algorithm: WorkoutMetricAlgorithm;
}

export enum WorkoutMetricAlgorithm {
    BEST_EFFORT = 'BEST_EFFORT'
}

export interface WorkoutCalculatedMetricDefinitionDto {
    /** @format int64 */
    id: number;
    metricKey: string;
    label: string;
    algorithm: WorkoutMetricAlgorithm;
    parameters: BestEffortParameters;
    /** @uniqueItems true */
    workoutTypes: WorkoutTypeV2[];
    enabled: boolean;
}

export enum BadgeOwnerType {
    COMMUNITY = 'COMMUNITY',
    USER = 'USER',
    SYSTEM = 'SYSTEM'
}

export enum BadgeStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED'
}

export interface BadgeTypeUpdateRequestDto {
    /** @format int64 */
    categoryId?: number;
    /** @format int64 */
    collectionId?: number;
    name?: object;
    description?: object;
    /** @format int32 */
    sortOrder?: number;
    status?: BadgeStatus;
    visibility?: BadgeVisibility;
    ownerType?: BadgeOwnerType;
    /** @format int64 */
    ownerCommunityId?: number;
    ownerUserId?: string;
    /** @format int64 */
    goalId?: number;
    goalConfig?: GoalConfigRequestDto;
    unlinkGoal?: boolean;
}

export enum BadgeVisibility {
    PUBLIC = 'PUBLIC',
    COMMUNITY_ONLY = 'COMMUNITY_ONLY',
    PRIVATE = 'PRIVATE'
}

export interface GoalConfigRequestDto {
    ruleType: GoalRuleType;
    fitnessMetricType?: GoalFitnessMetricType;
    aggregationType?: GoalAggregationType;
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    activityFilters?: any[];
    socialMetricType?: GoalSocialMetricType;
    targetValue: number;
    recurrence: RecurrenceType;
}

export interface BadgeTypeAdminDto {
    /** @format int64 */
    id: number;
    key: string;
    /** @format int64 */
    categoryId: number;
    categoryName: Record<string, string>;
    /** @format int64 */
    collectionId?: number;
    name: Record<string, string>;
    description?: object;
    /** @format int32 */
    sortOrder: number;
    status: BadgeStatus;
    visibility: BadgeVisibility;
    ownerType: BadgeOwnerType;
    /** @format int64 */
    ownerCommunityId?: number;
    ownerUserId?: string;
    /** @format int64 */
    goalId?: number;
    goalConfig?: GoalConfigDto;
    /** @format int64 */
    challengeId?: number;
    /** @format int32 */
    levelsCount: number;
    /** @format int32 */
    earnedByUsersCount: number;
    deleted: boolean;
}

export interface GoalConfigDto {
    /** @format int64 */
    goalId: number;
    goalKey: string;
    ruleType: GoalRuleType;
    fitnessMetricType?: GoalFitnessMetricType;
    aggregationType?: GoalAggregationType;
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    activityFilters?: any[];
    socialMetricType?: GoalSocialMetricType;
    targetValue: number;
    recurrence: RecurrenceType;
    levels: GoalRuleLevelAdminDto[];
}

export interface GoalRuleLevelAdminDto {
    /** @format int32 */
    levelIndex: number;
    threshold: number;
}

export interface BadgeLevelUpdateRequestDto {
    /** @format int32 */
    levelIndex?: number;
    name?: object;
    description?: object;
    image?: CdnObjectDto;
    threshold?: number;
}

export interface BadgeLevelAdminDto {
    /** @format int64 */
    id: number;
    /** @format int64 */
    badgeTypeId: number;
    badgeTypeName: Record<string, string>;
    /** @format int32 */
    levelIndex: number;
    name: Record<string, string>;
    description?: object;
    image?: CdnObjectDto;
    threshold: number;
    /** @format int32 */
    earnedByUsersCount: number;
    deleted: boolean;
}

export interface ChallengeBadgeUpdateRequestDto {
    name?: object;
    description?: object;
    image?: CdnObjectDto;
}

export interface BadgeCategoryUpdateRequestDto {
    name?: object;
    description?: object;
    badgeKind?: BadgeKind;
    /** @format int32 */
    sortOrder?: number;
    enabled?: boolean;
}

export enum BadgeKind {
    STANDARD = 'STANDARD',
    UNIQUE = 'UNIQUE',
    PERSONALIZED = 'PERSONALIZED'
}

export interface BadgeCategoryAdminDto {
    /** @format int64 */
    id: number;
    key: string;
    name: Record<string, string>;
    description?: object;
    badgeKind: BadgeKind;
    /** @format int32 */
    sortOrder: number;
    enabled: boolean;
    /** @format int32 */
    badgeTypesCount: number;
    deleted: boolean;
}

export interface ActivitySourceDto {
    /** @format int64 */
    id?: number;
    /** @minLength 1 */
    applicationPackage: string;
    stepsAllowed: boolean;
    workoutsAllowed: boolean;
    priority: ActivitySourcePriority;
    origin?: ActivitySourceOriginDto;
}

export interface ActivitySourceOriginDto {
    /** @format int64 */
    userId: number;
    /** @minLength 1 */
    tenantId: string;
}

export enum ActivitySourcePriority {
    HIGH = 'HIGH',
    LOW = 'LOW'
}

export interface ActivityPointsMultiplierTierDto {
    /** @format int64 */
    min: number;
    /** @format int64 */
    max?: number;
    multiplier: number;
}

export interface ActivityPointsMultiplierTierGroupUpdateRequestDto {
    tiers: ActivityPointsMultiplierTierDto[];
    activityType: ActivityType;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    recordingMethod?: WorkoutRecordingMethod;
    /** @format double */
    requiredAverageSpeed?: number;
    /** @format double */
    requiredCaloriesPerMinute?: number;
    /** @format int32 */
    priority: number;
}

export enum WorkoutRecordingMethod {
    GEOFENCE = 'GEOFENCE',
    GPS = 'GPS',
    ACCELEROMETER = 'ACCELEROMETER'
}

export interface ActivityPointsMultiplierTierGroupDto {
    /** @format int64 */
    id: number;
    tiers: ActivityPointsMultiplierTierDto[];
    activityType: ActivityType;
    workoutType?: WorkoutTypeV2;
    workoutCategory?: WorkoutCategory;
    recordingMethod?: WorkoutRecordingMethod;
    /** @format double */
    requiredAverageSpeed?: number;
    /** @format double */
    requiredCaloriesPerMinute?: number;
    /** @format int32 */
    priority: number;
}

export interface ActivityFlagDto {
    /** @format int64 */
    id: number;
    /** @format int64 */
    activityId: number;
    status: WorkoutFlagStatus;
    /** @minLength 1 */
    comment: string;
    /** @minLength 1 */
    createdBy: string;
    modifiedBy?: string;
}

export interface CommunityDailyGoalRequestV2Dto {
    rule: GoalRuleDto;
    timeZone: string;
    /** @format int64 */
    communityId: number;
    userIdsToAssign: string[];
    /** @format duration */
    rewardingDuration?: string;
    rewardValue?: number;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
}

export interface WorkoutTypeRuleCreateRequestDto {
    workoutType?: WorkoutTypeV2;
    workoutCategory?: WorkoutCategory;
    validationRule: WorkoutValidationRuleDto;
}

export interface UserBadgeV2RevokeRequestDto {
    /** @minLength 1 */
    revokedBy: string;
    reason?: string;
}

export interface BadgeCategorySummaryDto {
    /** @format int64 */
    id: number;
    name: Record<string, string>;
    badgeKind: string;
}

export interface BadgeLevelSummaryDto {
    /** @format int64 */
    id: number;
    /** @format int32 */
    levelIndex: number;
    name: Record<string, string>;
    description?: object;
    image?: CdnObjectDto;
}

export interface BadgeTypeSummaryDto {
    /** @format int64 */
    id: number;
    name: Record<string, string>;
    description?: object;
}

export enum UserBadgeSource {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL',
    IMPORT = 'IMPORT',
    CHALLENGE_REWARD = 'CHALLENGE_REWARD'
}

export enum UserBadgeStatus {
    EARNED = 'EARNED',
    CLAIMED = 'CLAIMED',
    REVOKED = 'REVOKED'
}

export interface UserBadgeV2AdminDetailDto {
    /** @format int64 */
    id: number;
    userId: string;
    badgeLevel: BadgeLevelSummaryDto;
    badgeType: BadgeTypeSummaryDto;
    badgeCategory: BadgeCategorySummaryDto;
    /** @format date-time */
    earnedAt: string;
    source: UserBadgeSource;
    sourceRef?: string;
    status: UserBadgeStatus;
    metadata?: object;
    /** @format date-time */
    revokedAt?: string;
    revokedBy?: string;
    /** @format date-time */
    createdDate: string;
    /** @format date-time */
    modifiedDate: string;
}

export enum Job {
    ALIGN_ACTIVITY_POINTS_DISCREPANCY = 'ALIGN_ACTIVITY_POINTS_DISCREPANCY',
    FIX_STEP_CHUNKS = 'FIX_STEP_CHUNKS'
}

export interface GoalReachedEventResendRequestDto {
    goalProgressIds: number[];
}

export interface GoalProgressInitRequestDto {
    /**
     * @format date
     * @example "2026-09-14"
     */
    day: string;
}

export interface GoalAssignmentRequestSupportDto {
    /** @format int64 */
    goalId: number;
    /** @minLength 1 */
    userId: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
}

export interface GoalAssignmentDto {
    /** @format int64 */
    id: number;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    rewardedDayTo?: string;
    notificationSettings: GoalNotificationSettingsDto;
}

export interface GoalNotificationSettingsDto {
    /**
     * @exclusiveMin 0
     * @max 1
     */
    remainingPercentage?: number;
    reachedEnabled?: boolean;
}

export interface FixFamilyAssignmentRequestSupportDto {
    goalIds: number[];
}

export enum CdnObjectType {
    GPX = 'GPX',
    MAP_IMAGE = 'MAP_IMAGE',
    ACTIVITY_IMAGE = 'ACTIVITY_IMAGE',
    BADGE_IMAGE = 'BADGE_IMAGE'
}

export enum ActivityEventType {
    STEPS_PER_DAY = 'STEPS_PER_DAY',
    STEPS_PER_EPOCH = 'STEPS_PER_EPOCH',
    FACILITY_VISIT = 'FACILITY_VISIT',
    WORKOUT = 'WORKOUT',
    WORKOUT_FIT_FILE = 'WORKOUT_FIT_FILE'
}

export interface FacilityVisitEvent {
    /** @format uuid */
    messageId: string;
    /** @minLength 1 */
    userId: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    userDay: string;
    /** @format date-time */
    timestamp: string;
    fitnessApp: SupportedFitnessApp;
    device: string;
    /** @format int64 */
    facilityId: number;
    facilityName: string;
    /** @format int64 */
    checkInId: number;
    facilityVisitType: FacilityVisitType;
    visitDateRange: ZonedDateTimeRangeDto;
    type: ActivityEventType;
    /** @uniqueItems true */
    sources: string[];
}

export enum FacilityVisitType {
    MANUAL = 'MANUAL',
    AUTOMATIC = 'AUTOMATIC',
    PUBLIC_FACILITY = 'PUBLIC_FACILITY',
    PRIVATE_FACILITY = 'PRIVATE_FACILITY'
}

export enum SupportedFitnessApp {
    STRAVA = 'STRAVA',
    GARMIN = 'GARMIN',
    FITBIT = 'FITBIT',
    POLAR = 'POLAR',
    MYSPORTS_REWARDS = 'MYSPORTS_REWARDS',
    MOVE_REPUBLIC = 'MOVE_REPUBLIC',
    MOVE_REPUBLIC_ADMIN = 'MOVE_REPUBLIC_ADMIN',
    GOOGLE_FIT = 'GOOGLE_FIT',
    HEALTH_CONNECT = 'HEALTH_CONNECT',
    WITHINGS = 'WITHINGS',
    APPLE_HEALTH = 'APPLE_HEALTH',
    HUAWEI_HEALTH = 'HUAWEI_HEALTH',
    SAMSUNG_HEALTH = 'SAMSUNG_HEALTH',
    SUUNTO = 'SUUNTO',
    ZEPP = 'ZEPP',
    GOOGLE_HEALTH = 'GOOGLE_HEALTH'
}

export interface ZonedDateTimeRangeDto {
    /** @format date-time */
    from: string;
    /** @format date-time */
    to: string;
    /**
     * @deprecated
     * @format date-time
     */
    startDateTime: string;
    /**
     * @deprecated
     * @format date-time
     */
    endDateTime: string;
}

export interface CreateCompositePointDefinitionRequestDto {
    /** @format int64 */
    communityId: number;
    /** @minLength 1 */
    pointTypeKey: string;
    /**
     * @minLength 0
     * @maxLength 255
     */
    label: string;
    /**
     * @minLength 0
     * @maxLength 10000
     */
    symbolSvg?: string;
    enabled: boolean;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    /**
     * @maxItems 2147483647
     * @minItems 1
     */
    sourceRules: CreateCompositePointSourceRuleRequestDto[];
}

export interface CommunityDailyGoalRequestV3Dto {
    /** @format int64 */
    communityId: number;
    tenantId?: string;
    timeZone: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
    rule: GoalRuleDto;
    rewardConfigs: RewardConfigDto[];
    streakEnabled?: boolean;
    userIdsToAssign: string[];
    autoAssignEnabled: boolean;
    recurrence?: RecurrenceType;
    visibleInApp: boolean;
    name?: string;
    /** @format duration */
    rewardingDuration?: string;
}

export interface CommunityDailyGoalRequestDto {
    /**
     * @format int32
     * @exclusiveMin 0
     */
    activityPoints: number;
    timeZone: string;
    /** @format int64 */
    communityId: number;
    userIdsToAssign: string[];
    autoAssignEnabled: boolean;
    /** @format duration */
    rewardingDuration?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
}

export interface CreateWorkoutCalculatedMetricDefinitionRequestDto {
    /** @minLength 1 */
    metricKey: string;
    /** @minLength 1 */
    label: string;
    parameters: BestEffortParameters;
    /**
     * @minItems 1
     * @uniqueItems true
     */
    workoutTypes: WorkoutTypeV2[];
    enabled: boolean;
}

export interface BadgeTypeCreateRequestDto {
    key: string;
    /** @format int64 */
    categoryId: number;
    /** @format int64 */
    collectionId?: number;
    name: Record<string, string>;
    description?: object;
    /** @format int32 */
    sortOrder: number;
    status: BadgeStatus;
    visibility: BadgeVisibility;
    ownerType: BadgeOwnerType;
    /** @format int64 */
    ownerCommunityId?: number;
    ownerUserId?: string;
    /** @format int64 */
    goalId?: number;
    goalConfig?: GoalConfigRequestDto;
}

export interface BadgeLevelCreateRequestDto {
    /** @format int64 */
    badgeTypeId: number;
    /** @format int32 */
    levelIndex: number;
    name: Record<string, string>;
    description?: object;
    image?: CdnObjectDto;
    threshold: number;
}

export interface ChallengeBadgeCreateRequestDto {
    name: Record<string, string>;
    description?: object;
    image?: CdnObjectDto;
    /** @format int64 */
    challengeId: number;
    /** @format int64 */
    communityId: number;
}

export interface BadgeCategoryCreateRequestDto {
    key: string;
    name: Record<string, string>;
    description?: object;
    badgeKind: BadgeKind;
    /** @format int32 */
    sortOrder: number;
    enabled: boolean;
}

export interface UserBadgeAssignmentRequestDto {
    /** @minItems 1 */
    userIds: string[];
    /** @minItems 1 */
    badgeLevelIds: number[];
}

export interface UserBadgeAssignmentResponseDto {
    /** @format int32 */
    totalRequested: number;
    /** @format int32 */
    successCount: number;
    /** @format int32 */
    alreadyAssignedCount: number;
    /** @format int32 */
    failedCount: number;
    results: UserBadgeAssignmentResultDto[];
}

export interface UserBadgeAssignmentResultDto {
    userId: string;
    /** @format int64 */
    badgeLevelId: number;
    badgeLevelName: Record<string, string>;
    badgeTypeName: Record<string, string>;
    success: boolean;
    alreadyAssigned: boolean;
    errorMessage?: string;
}

export interface GoalAssignmentFromBadgeRequestDto {
    /** @minItems 1 */
    userIds: string[];
    /** @minItems 1 */
    badgeTypeIds: number[];
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
}

export interface GoalAssignmentFromBadgeResponseDto {
    /** @format int32 */
    totalRequested: number;
    /** @format int32 */
    successCount: number;
    /** @format int32 */
    alreadyAssignedCount: number;
    /** @format int32 */
    failedCount: number;
    /** @format int32 */
    noGoalCount: number;
    results: GoalAssignmentFromBadgeResultDto[];
}

export interface GoalAssignmentFromBadgeResultDto {
    userId: string;
    /** @format int64 */
    badgeTypeId: number;
    badgeTypeName: Record<string, string>;
    /** @format int64 */
    goalId?: number;
    /** @format int64 */
    goalAssignmentId?: number;
    success: boolean;
    alreadyAssigned: boolean;
    errorMessage?: string;
}

export interface ActivityPointsMultiplierTierGroupCreateRequestDto {
    tiers: ActivityPointsMultiplierTierDto[];
    activityType: ActivityType;
    workoutType?: WorkoutTypeV2;
    workoutCategory?: WorkoutCategory;
    recordingMethod?: WorkoutRecordingMethod;
    /** @format double */
    requiredAverageSpeed?: number;
    /** @format double */
    requiredCaloriesPerMinute?: number;
    /** @format int32 */
    priority: number;
}

export interface ActivityPointTransactionExportRequestDto {
    ids: number[];
}

export interface ActivityFlagCreateResponseDto {
    activityFlag: ActivityFlagDto;
    userFlagCreated: boolean;
}

export interface ActivityBackfillDto {
    /** @format date-time */
    backfillDateTime: string;
}

export enum ActivityVisibility {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE'
}

export enum CheckInType {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE'
}

export interface WorkoutEvent {
    /** @format uuid */
    messageId: string;
    /** @minLength 1 */
    userId: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    userDay: string;
    /** @format date-time */
    timestamp: string;
    fitnessApp: SupportedFitnessApp;
    device: string;
    payload: WorkoutPayloadDto;
    type: ActivityEventType;
    /** @uniqueItems true */
    sources: string[];
}

export interface WorkoutHeartRateEntryDto {
    /** @format date-time */
    timestamp: string;
    /** @format int32 */
    value: number;
}

export interface WorkoutMetadataDto {
    wasInRestrictedArea: boolean;
    /** @format double */
    minBatteryLevel: number;
    customFields: Record<string, any>;
}

export interface WorkoutPayloadDto {
    workoutType: WorkoutType;
    workoutTypeV2: WorkoutTypeV2;
    rawWorkoutType: string;
    recordingMethod: WorkoutRecordingMethod;
    /** @uniqueItems true */
    sources: string[];
    /** @uniqueItems true */
    devices: string[];
    device: string;
    dateTimeRange: ZonedDateTimeRangeDto;
    properties: WorkoutPropertiesDto;
    rawData: string;
    gpx: CdnObjectDto;
    tcx: CdnObjectDto;
    fitFile: CdnObjectDto;
    mapImage: CdnObjectDto;
    activityImages: CdnObjectDto[];
    metadata: WorkoutMetadataDto;
    visibility: ActivityVisibility;
}

export interface WorkoutPropertiesDto {
    /** @format double */
    distance: number;
    /**
     * @deprecated
     * @format double
     */
    elevation: number;
    /** @format double */
    averageSpeed: number;
    /** @format double */
    activityTime: number;
    /** @format double */
    maximumSpeed: number;
    /** @format double */
    averageHeartRate: number;
    /** @format double */
    maximumHeartRate: number;
    /** @format double */
    caloriesBurned: number;
    /** @format double */
    elevationGain: number;
    /** @format double */
    elevationLoss: number;
    /** @format double */
    stepCount: number;
    speedEntries: WorkoutSpeedEntryDto[];
    heartRateEntries: WorkoutHeartRateEntryDto[];
    externalId: string;
    /** @format int64 */
    facilityId: number;
    checkInType: CheckInType;
    validationPhoto: CdnObjectDto;
}

export interface WorkoutSpeedEntryDto {
    /** @format date-time */
    timestamp: string;
    /** @format date-time */
    startTime: string;
    /** @format date-time */
    endTime: string;
    value: number;
}

export enum WorkoutType {
    CYCLING = 'CYCLING',
    RUNNING = 'RUNNING',
    HIKING = 'HIKING',
    OTHER = 'OTHER'
}

export enum ActivityPriority {
    LOW = 'LOW',
    HIGH = 'HIGH',
    FORCE_OVERRIDE = 'FORCE_OVERRIDE'
}

export interface DailyStepsEvent {
    /** @format uuid */
    messageId: string;
    /** @minLength 1 */
    userId: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    userDay: string;
    /** @format date-time */
    timestamp: string;
    fitnessApp: SupportedFitnessApp;
    device: string;
    /**
     * @format int32
     * @exclusiveMin 0
     */
    stepCount: number;
    dateTimeRange: ZonedDateTimeRangeDto;
    priority: ActivityPriority;
    /** @uniqueItems true */
    sources: string[];
    type: ActivityEventType;
}

export interface ActivityRejectionRequestDto {
    /** @minItems 1 */
    activityIds: number[];
}

export interface CommunityGoalAdminUpdateRequestDto {
    /** @format int64 */
    communityId: number;
    rule?: GoalRuleDto;
    rewardConfigs?: any[];
    recurrence?: RecurrenceType;
    streakEnabled?: boolean;
    autoAssignEnabled?: boolean;
    visibleInApp?: boolean;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
    name?: string;
}

export enum ActivityRejectionReason {
    INVALID_SOURCE = 'INVALID_SOURCE',
    INVALID_AVERAGE_SPEED = 'INVALID_AVERAGE_SPEED',
    INVALID_MAX_SPEED = 'INVALID_MAX_SPEED',
    TOO_SHORT = 'TOO_SHORT',
    INVALID_CALORIES_PER_MINUTE = 'INVALID_CALORIES_PER_MINUTE',
    RESTRICTED_AREA = 'RESTRICTED_AREA',
    OVERWRITTEN_BY_OTHER_ACTIVITY = 'OVERWRITTEN_BY_OTHER_ACTIVITY',
    FACILITY_REJECTED = 'FACILITY_REJECTED',
    REJECTED_BY_MAPPING = 'REJECTED_BY_MAPPING',
    REJECTED_BY_SUPPORT = 'REJECTED_BY_SUPPORT',
    REJECTED_BY_USER = 'REJECTED_BY_USER'
}

export interface PageWorkoutReviewDto {
    content: WorkoutReviewDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface WorkoutReviewDto {
    /** @format int64 */
    id: number;
    workoutType: WorkoutType;
    workoutTypeV2?: WorkoutTypeV2;
    recordingMethod?: WorkoutRecordingMethod;
    checkInType?: CheckInType;
    /** @format int64 */
    facilityId?: number;
    facilityName?: string;
    verificationRequired: boolean;
    rejectionReason?: ActivityRejectionReason;
    zonedDateTimeRangeModel: ZonedDateTimeRangeDto;
    /** @minLength 1 */
    userId: string;
}

export interface UserProfileDto {
    /** @minLength 1 */
    id: string;
    /** @minLength 1 */
    userId: string;
    /** @minLength 1 */
    firstName: string;
    /** @minLength 1 */
    lastName: string;
    image: CdnObjectDto;
}

export interface WorkoutReviewDetailsDto {
    baseData: WorkoutReviewDto;
    userProfile: UserProfileDto;
    /** @format uri */
    validationPhotoUrl?: string;
}

export interface PageWorkoutTypeRuleDto {
    content: WorkoutTypeRuleDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageWorkoutTypeMappingDto {
    content: WorkoutTypeMappingDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface WorkoutCategoryWithTypesDto {
    category: WorkoutCategory;
    types: WorkoutTypeV2[];
}

export enum GoalAssignmentStatus {
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    EXPIRED = 'EXPIRED',
    PENDING = 'PENDING'
}

export interface LinkedBadgeTypeSummaryDto {
    /** @format int64 */
    badgeTypeId: number;
    badgeTypeKey: string;
    badgeTypeName: Record<string, string>;
}

export interface PageUserGoalAssignmentAdminDto {
    content: UserGoalAssignmentAdminDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface UserGoalAssignmentAdminDto {
    /** @format int64 */
    id: number;
    userId: string;
    /** @format int64 */
    goalId: number;
    goalKey: string;
    goalOwner: GoalOwnerDto;
    goalRecurrence: RecurrenceType;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayFrom: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    dayTo?: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    rewardedDayTo?: string;
    linkedBadgeTypes: LinkedBadgeTypeSummaryDto[];
    currentProgress?: number;
    goalTargetValue: number;
    progressReached?: boolean;
    status: GoalAssignmentStatus;
}

export interface PageUserBadgeV2AdminDto {
    content: UserBadgeV2AdminDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface UserBadgeV2AdminDto {
    /** @format int64 */
    id: number;
    userId: string;
    /** @format int64 */
    badgeLevelId: number;
    badgeLevelName: Record<string, string>;
    /** @format int32 */
    badgeLevelIndex: number;
    /** @format int64 */
    badgeTypeId: number;
    badgeTypeName: Record<string, string>;
    /** @format int64 */
    badgeCategoryId: number;
    badgeCategoryName: Record<string, string>;
    /** @format date-time */
    earnedAt: string;
    source: UserBadgeSource;
    sourceRef?: string;
    status: UserBadgeStatus;
    image?: CdnObjectDto;
    /** @format date-time */
    revokedAt?: string;
    revokedBy?: string;
    /** @format date-time */
    createdDate: string;
    /** @format date-time */
    modifiedDate: string;
}

export interface PageUserFlagDto {
    content: UserFlagDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageGoalDto {
    content: GoalDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface GoalProgressDto {
    /** @format int64 */
    id?: number;
    goal?: GoalDto;
    /**
     * @format date
     * @example "2026-09-14"
     */
    day: string;
    /** @min 0 */
    value: number;
    /** @min 0 */
    currentLevelProgressRelative: number;
    /** @min 0 */
    currentLevelProgressAbsolute: number;
    /** @format int32 */
    levelIndex: number;
    /** @format int32 */
    streak: number;
    /** @min 0 */
    points: number;
    reward?: RewardDto;
    rewardWithheldReason?: RewardWithheldReason;
    userId?: string;
}

export interface PageGoalProgressDto {
    content: GoalProgressDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface RewardBadgeDto {
    /** @format int64 */
    badgeTypeId: number;
    /** @format int64 */
    badgeLevelId: number;
    /** @format date-time */
    earnedAt: string;
}

export interface RewardDto {
    /** @exclusiveMin 0 */
    value?: number;
    currencyCode?: string;
    /** @format date-time */
    date: string;
    badge?: RewardBadgeDto;
}

export enum RewardWithheldReason {
    REWARD_LIMIT_REACHED = 'REWARD_LIMIT_REACHED'
}

export interface ActivityFlagSummaryDto {
    /** @format int64 */
    id: number;
    status: WorkoutFlagStatus;
    comment: string;
    createdBy: string;
    modifiedBy?: string;
}

export interface ActivityOverviewSupportDto {
    userId: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    userDay: string;
    dailySteps: DailyStepsEntryDto[];
    activityPointsChanges: ActivityPointsChangeEntryDto[];
    workouts: WorkoutEntryDto[];
    facilityVisits: FacilityVisitEntryDto[];
    activityFlags: Record<string, ActivityFlagSummaryDto>;
    userFlag?: UserFlagSummaryDto;
}

export interface ActivityPointsChangeEntryDto {
    /** @format date-time */
    apChangeTimestamp: string;
    value: number;
    /** @format int64 */
    activityId: number;
    /** @format date-time */
    activityTimestamp: string;
    activityDateTimeRange: ZonedDateTimeRangeDto;
    activityType: ActivityType;
}

export interface DailyStepsChunkDto {
    timeRange: ZonedDateTimeRangeDto;
    /** @format int32 */
    stepCount: number;
    stepsChunkType: StepsActivityChunkType;
}

export interface DailyStepsEntryDto {
    /** @format int64 */
    id: number;
    fitnessApp?: SupportedFitnessApp;
    /** @format int32 */
    stepCount: number;
    rejected: boolean;
    /** @format double */
    activityPoints: number;
    chunks: DailyStepsChunkDto[];
}

export interface FacilityVisitEntryDto {
    /** @format int64 */
    id: number;
    facilityName?: string;
    visitType: FacilityVisitType;
    location?: GeoPointWithAccuracyDto;
    facilityVisitEntryDateTimeRange: ZonedDateTimeRangeDto;
}

export interface GeoPointWithAccuracyDto {
    /** @format double */
    latitude: number;
    /** @format double */
    longitude: number;
    /** @format double */
    altitude?: number;
    /** @format double */
    accuracy: number;
}

export enum GpxAnalysisAction {
    ACCEPT = 'ACCEPT',
    ACCEPT_DIRTY = 'ACCEPT_DIRTY',
    REVIEW = 'REVIEW',
    VEHICLE = 'VEHICLE',
    CORRUPT = 'CORRUPT'
}

export enum StepsActivityChunkType {
    WALKING = 'WALKING',
    RUNNING = 'RUNNING'
}

export interface UserFlagSummaryDto {
    /** @format int64 */
    id: number;
    status: WorkoutFlagStatus;
    comment: string;
    createdBy: string;
    /** @format int32 */
    flaggedActivityCount: number;
}

export interface WorkoutEntryDto {
    /** @format int64 */
    id: number;
    workoutCategory: WorkoutCategory;
    workoutType: WorkoutTypeV2;
    workoutDateTimeRange: ZonedDateTimeRangeDto;
    activityRejectionReason?: ActivityRejectionReason;
    /** @format url */
    gpxFileUrl?: string;
    /** @format url */
    tcxFileUrl?: string;
    gpxAnalysis?: WorkoutGpxAnalysisSummaryDto;
}

export interface WorkoutGpxAnalysisSummaryDto {
    action: GpxAnalysisAction;
    /** @format date-time */
    analysedAt: string;
    result: Record<string, any>;
}

export interface FacilityVisitDto {
    /** @format int64 */
    id: number;
    visitType: FacilityVisitType;
    /** @format int64 */
    facilityId?: number;
    facilityName?: string;
    verificationRequired: boolean;
    rejectionReason?: ActivityRejectionReason;
    zonedDateTimeRangeModel: ZonedDateTimeRangeDto;
    /** @minLength 1 */
    userId: string;
}

export interface PageFacilityVisitDto {
    content: FacilityVisitDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface CheckInDto {
    /** @format int64 */
    id: number;
    startLocation: GeoPointWithAccuracyDto;
    checkOutReason?: CheckOutReason;
    /**
     * @format uri
     * @minLength 1
     */
    photoUrl: string;
}

export enum CheckOutReason {
    MANUAL = 'MANUAL',
    DISTANCE = 'DISTANCE',
    TIMEOUT = 'TIMEOUT'
}

export interface FacilityVisitDetailsDto {
    baseData: FacilityVisitDto;
    userProfile: UserProfileDto;
    checkIn?: CheckInDto;
}

export interface PageBadgeTypeAdminDto {
    content: BadgeTypeAdminDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageBadgeLevelAdminDto {
    content: BadgeLevelAdminDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageBadgeCategoryAdminDto {
    content: BadgeCategoryAdminDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageActivitySourceDto {
    content: ActivitySourceDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface ActivityPointsChangeDto {
    /** @format date-time */
    createdDate: string;
    /** @format date-time */
    timestamp: string;
    value: number;
}

export interface ActivityPointsDto {
    /** @format int64 */
    id: number;
    /** @format date-time */
    timestamp: string;
    activityType: ActivityType;
    value: number;
    changes: ActivityPointsChangeDto[];
}

export interface PageActivityPointsDto {
    content: ActivityPointsDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export enum ActivityDataType {
    STEPS = 'STEPS',
    DISTANCE = 'DISTANCE',
    TIME = 'TIME'
}

export interface ActivityPointChangeEvent {
    /** @format int64 */
    changeId: number;
    activityId: string;
    value: number;
    /** @format date-time */
    timestamp: string;
    /**
     * @format date
     * @example "2026-09-14"
     */
    userDay: string;
    activityType: ActivityType;
    activityDataType: ActivityDataType;
    activityValue: number;
    workoutCategory: WorkoutCategory;
    workoutType: WorkoutTypeV2;
}

export interface ActivityPointsSummaryDto {
    /** @min 0 */
    activityPoints: number;
    activityPointChanges: ActivityPointChangeEvent[];
}

export interface PageActivityPointsMultiplierTierGroupDto {
    content: ActivityPointsMultiplierTierGroupDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageActivityPointsChangeDto {
    content: ActivityPointsChangeDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageActivityFlagDto {
    content: ActivityFlagDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface ActivityDto {
    /** @format int64 */
    id: number;
    type: ActivityType;
    /** @format date-time */
    timestamp: string;
    rejected: boolean;
    dateTimeRange: ZonedDateTimeRangeDto;
    workoutCategory?: WorkoutCategory;
    workoutTypeV2?: WorkoutTypeV2;
    rejectionReason?: ActivityRejectionReason;
    gpxAnalysisAction?: GpxAnalysisAction;
}

export interface PageActivityDto {
    content: ActivityDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface ActivityDetailsSupportDto {
    /** @format int64 */
    id: number;
    type: ActivityType;
    /** @format date-time */
    timestamp: string;
    rejected: boolean;
    dateTimeRange: ZonedDateTimeRangeDto;
    workoutCategory?: WorkoutCategory;
    workoutTypeV2?: WorkoutTypeV2;
    rejectionReason?: ActivityRejectionReason;
    gpxAnalysisAction?: GpxAnalysisAction;
    hidden: boolean;
    /** @format date-time */
    createdDate: string;
    /** @format date-time */
    modifiedDate: string;
    activityPoints: number;
    additionalProperties: KeyValuePairStringObject[];
    backfill?: ActivityBackfillDto;
    /** @format url */
    gpxFileUrl?: string;
    /** @format url */
    tcxFileUrl?: string;
    gpxAnalysis?: WorkoutGpxAnalysisSummaryDto;
}

export interface KeyValuePairStringObject {
    key: string;
    value: any;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<
    FullRequestParams,
    'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
    securityWorker?: (
        securityData: SecurityDataType | null
    ) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
    extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = '/corporate-api';
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
        fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter(
            (key) => 'undefined' !== typeof query[key]
        );
        return keys
            .map((key) =>
                Array.isArray(query[key])
                    ? this.addArrayQueryParam(query, key)
                    : this.addQueryParam(query, key)
            )
            .join('&');
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null &&
            (typeof input === 'object' || typeof input === 'string')
                ? JSON.stringify(input)
                : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string'
                ? JSON.stringify(input)
                : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                          ? JSON.stringify(property)
                          : `${property}`
                );
                return formData;
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
    };

    protected mergeRequestParams(
        params1: RequestParams,
        params2?: RequestParams
    ): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {})
            }
        };
    }

    protected createAbortSignal = (
        cancelToken: CancelToken
    ): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean'
                ? secure
                : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter =
            this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(
            `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
            {
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData
                        ? { 'Content-Type': type }
                        : {})
                },
                signal:
                    (cancelToken
                        ? this.createAbortSignal(cancelToken)
                        : requestParams.signal) || null,
                body:
                    typeof body === 'undefined' || body === null
                        ? null
                        : payloadFormatter(body)
            }
        ).then(async (response) => {
            const r = response.clone() as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data;
        });
    };
}

/**
 * @title MySports Rewards Fitness Activity API
 * @version v1
 * @license MySports License (https://www.mysports.com)
 * @baseUrl /corporate-api
 * @contact MySports Contact <move@mysports-rewards.com>
 *
 * Service that provides Fitness Activity APIs
 */
export class Api<
    SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
    admin = {
        /**
         * No description
         *
         * @tags workout-type-rule-controller
         * @name WorkoutTypeRuleControllerGetDetails
         * @request GET:/admin/v1/workout-type-rules/{id}
         * @secure
         */
        workoutTypeRuleControllerGetDetails: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<WorkoutTypeRuleDto, any>({
                path: `/admin/v1/workout-type-rules/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-type-rule-controller
         * @name WorkoutTypeRuleControllerUpdate
         * @request PUT:/admin/v1/workout-type-rules/{id}
         * @secure
         */
        workoutTypeRuleControllerUpdate: (
            id: number,
            data: WorkoutTypeRuleUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<WorkoutTypeRuleDto, any>({
                path: `/admin/v1/workout-type-rules/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-type-rule-controller
         * @name WorkoutTypeRuleControllerDelete
         * @request DELETE:/admin/v1/workout-type-rules/{id}
         * @secure
         */
        workoutTypeRuleControllerDelete: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/workout-type-rules/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-type-mapping-admin-controller
         * @name WorkoutTypeMappingAdminControllerGetPage
         * @request GET:/admin/v1/workout-type-mappings
         * @secure
         */
        workoutTypeMappingAdminControllerGetPage: (
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
                workoutType?: string;
                rejected?: boolean;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageWorkoutTypeMappingDto, any>({
                path: `/admin/v1/workout-type-mappings`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-type-mapping-admin-controller
         * @name WorkoutTypeMappingAdminControllerUpdate
         * @request PUT:/admin/v1/workout-type-mappings
         * @secure
         */
        workoutTypeMappingAdminControllerUpdate: (
            data: WorkoutTypeMappingUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<WorkoutTypeMappingDto, any>({
                path: `/admin/v1/workout-type-mappings`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-type-mapping-admin-controller
         * @name WorkoutTypeMappingAdminControllerBatchUpdate
         * @request PUT:/admin/v1/workout-type-mappings/batch
         * @secure
         */
        workoutTypeMappingAdminControllerBatchUpdate: (
            data: WorkoutTypeMappingUpdateRequestDto[],
            params: RequestParams = {}
        ) =>
            this.request<WorkoutTypeMappingBatchUpdateResponseDto, any>({
                path: `/admin/v1/workout-type-mappings/batch`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-rule-admin-controller
         * @name WorkoutRuleAdminControllerGetGlobalWorkoutRules
         * @request GET:/admin/v1/workout-rules/global
         * @secure
         */
        workoutRuleAdminControllerGetGlobalWorkoutRules: (
            params: RequestParams = {}
        ) =>
            this.request<WorkoutRuleDto, any>({
                path: `/admin/v1/workout-rules/global`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-rule-admin-controller
         * @name WorkoutRuleAdminControllerUpdateGlobalWorkoutRules
         * @request PUT:/admin/v1/workout-rules/global
         * @secure
         */
        workoutRuleAdminControllerUpdateGlobalWorkoutRules: (
            data: WorkoutRuleDto,
            params: RequestParams = {}
        ) =>
            this.request<WorkoutRuleDto, any>({
                path: `/admin/v1/workout-rules/global`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-flag-controller
         * @name UserFlagControllerGetUserFlagById
         * @request GET:/admin/v1/user-flags/{id}
         * @secure
         */
        userFlagControllerGetUserFlagById: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<UserFlagDto, any>({
                path: `/admin/v1/user-flags/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-flag-controller
         * @name UserFlagControllerUpdateUserFlag
         * @request PUT:/admin/v1/user-flags/{id}
         * @secure
         */
        userFlagControllerUpdateUserFlag: (
            id: number,
            data: UserFlagDto,
            params: RequestParams = {}
        ) =>
            this.request<UserFlagDto, any>({
                path: `/admin/v1/user-flags/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags composite-point-definition-controller
         * @name CompositePointDefinitionControllerGetById
         * @request GET:/admin/v1/composite-point-definitions/{id}
         * @secure
         */
        compositePointDefinitionControllerGetById: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<CompositePointDefinitionDto, any>({
                path: `/admin/v1/composite-point-definitions/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags composite-point-definition-controller
         * @name CompositePointDefinitionControllerUpdate
         * @request PUT:/admin/v1/composite-point-definitions/{id}
         * @secure
         */
        compositePointDefinitionControllerUpdate: (
            id: number,
            data: UpdateCompositePointDefinitionRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CompositePointDefinitionDto, any>({
                path: `/admin/v1/composite-point-definitions/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags composite-point-definition-controller
         * @name CompositePointDefinitionControllerDelete
         * @request DELETE:/admin/v1/composite-point-definitions/{id}
         * @secure
         */
        compositePointDefinitionControllerDelete: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/composite-point-definitions/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-support-controller
         * @name GoalSupportControllerUpdateCommunityGoal
         * @request PUT:/admin/v1/community-goals/{key}
         * @secure
         */
        goalSupportControllerUpdateCommunityGoal: (
            key: string,
            data: CommunityGoalUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<GoalDto, any>({
                path: `/admin/v1/community-goals/${key}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-goal-admin-controller
         * @name CommunityGoalAdminControllerDeleteCommunityGoal
         * @request DELETE:/admin/v1/community-goals/{key}
         * @secure
         */
        communityGoalAdminControllerDeleteCommunityGoal: (
            key: string,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/community-goals/${key}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-goal-admin-controller
         * @name CommunityGoalAdminControllerUpdateCommunityGoal
         * @request PATCH:/admin/v1/community-goals/{key}
         * @secure
         */
        communityGoalAdminControllerUpdateCommunityGoal: (
            key: string,
            data: CommunityGoalAdminUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<GoalDto, any>({
                path: `/admin/v1/community-goals/${key}`,
                method: 'PATCH',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-calculated-metric-definition-controller
         * @name WorkoutCalculatedMetricDefinitionControllerGetById
         * @request GET:/admin/v1/calculated-metric-definitions/{id}
         * @secure
         */
        workoutCalculatedMetricDefinitionControllerGetById: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<WorkoutCalculatedMetricDefinitionDto, any>({
                path: `/admin/v1/calculated-metric-definitions/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-calculated-metric-definition-controller
         * @name WorkoutCalculatedMetricDefinitionControllerUpdate
         * @request PUT:/admin/v1/calculated-metric-definitions/{id}
         * @secure
         */
        workoutCalculatedMetricDefinitionControllerUpdate: (
            id: number,
            data: UpdateWorkoutCalculatedMetricDefinitionRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<WorkoutCalculatedMetricDefinitionDto, any>({
                path: `/admin/v1/calculated-metric-definitions/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-calculated-metric-definition-controller
         * @name WorkoutCalculatedMetricDefinitionControllerDelete
         * @request DELETE:/admin/v1/calculated-metric-definitions/{id}
         * @secure
         */
        workoutCalculatedMetricDefinitionControllerDelete: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/calculated-metric-definitions/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-type-admin-controller
         * @name BadgeTypeAdminControllerGetType
         * @request GET:/admin/v1/badges/types/{id}
         * @secure
         */
        badgeTypeAdminControllerGetType: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<BadgeTypeAdminDto, any>({
                path: `/admin/v1/badges/types/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-type-admin-controller
         * @name BadgeTypeAdminControllerUpdateType
         * @request PUT:/admin/v1/badges/types/{id}
         * @secure
         */
        badgeTypeAdminControllerUpdateType: (
            id: number,
            data: BadgeTypeUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<BadgeTypeAdminDto, any>({
                path: `/admin/v1/badges/types/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-type-admin-controller
         * @name BadgeTypeAdminControllerDeleteType
         * @request DELETE:/admin/v1/badges/types/{id}
         * @secure
         */
        badgeTypeAdminControllerDeleteType: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/badges/types/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-level-admin-controller
         * @name BadgeLevelAdminControllerGetLevel
         * @request GET:/admin/v1/badges/levels/{id}
         * @secure
         */
        badgeLevelAdminControllerGetLevel: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<BadgeLevelAdminDto, any>({
                path: `/admin/v1/badges/levels/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-level-admin-controller
         * @name BadgeLevelAdminControllerUpdateLevel
         * @request PUT:/admin/v1/badges/levels/{id}
         * @secure
         */
        badgeLevelAdminControllerUpdateLevel: (
            id: number,
            data: BadgeLevelUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<BadgeLevelAdminDto, any>({
                path: `/admin/v1/badges/levels/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-level-admin-controller
         * @name BadgeLevelAdminControllerDeleteLevel
         * @request DELETE:/admin/v1/badges/levels/{id}
         * @secure
         */
        badgeLevelAdminControllerDeleteLevel: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/badges/levels/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-type-admin-controller
         * @name BadgeTypeAdminControllerUpdateChallengeBadge
         * @request PUT:/admin/v1/badges/challenge-badge/{badgeTypeId}
         * @secure
         */
        badgeTypeAdminControllerUpdateChallengeBadge: (
            badgeTypeId: number,
            data: ChallengeBadgeUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<BadgeTypeAdminDto, any>({
                path: `/admin/v1/badges/challenge-badge/${badgeTypeId}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-category-admin-controller
         * @name BadgeCategoryAdminControllerGetCategory
         * @request GET:/admin/v1/badges/categories/{id}
         * @secure
         */
        badgeCategoryAdminControllerGetCategory: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<BadgeCategoryAdminDto, any>({
                path: `/admin/v1/badges/categories/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-category-admin-controller
         * @name BadgeCategoryAdminControllerUpdateCategory
         * @request PUT:/admin/v1/badges/categories/{id}
         * @secure
         */
        badgeCategoryAdminControllerUpdateCategory: (
            id: number,
            data: BadgeCategoryUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<BadgeCategoryAdminDto, any>({
                path: `/admin/v1/badges/categories/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-category-admin-controller
         * @name BadgeCategoryAdminControllerDeleteCategory
         * @request DELETE:/admin/v1/badges/categories/{id}
         * @secure
         */
        badgeCategoryAdminControllerDeleteCategory: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/badges/categories/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-source-admin-controller
         * @name ActivitySourceAdminControllerGetActivitySource
         * @request GET:/admin/v1/activity-sources/{id}
         * @secure
         */
        activitySourceAdminControllerGetActivitySource: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ActivitySourceDto, any>({
                path: `/admin/v1/activity-sources/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-source-admin-controller
         * @name ActivitySourceAdminControllerUpdateActivitySource
         * @request PUT:/admin/v1/activity-sources/{id}
         * @secure
         */
        activitySourceAdminControllerUpdateActivitySource: (
            id: number,
            data: ActivitySourceDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activity-sources/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-points-multiplier-tier-group-controller
         * @name ActivityPointsMultiplierTierGroupControllerGetDetails
         * @request GET:/admin/v1/activity-points-multiplier-tier-groups/{id}
         * @secure
         */
        activityPointsMultiplierTierGroupControllerGetDetails: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ActivityPointsMultiplierTierGroupDto, any>({
                path: `/admin/v1/activity-points-multiplier-tier-groups/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-points-multiplier-tier-group-controller
         * @name ActivityPointsMultiplierTierGroupControllerUpdate
         * @request PUT:/admin/v1/activity-points-multiplier-tier-groups/{id}
         * @secure
         */
        activityPointsMultiplierTierGroupControllerUpdate: (
            id: number,
            data: ActivityPointsMultiplierTierGroupUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ActivityPointsMultiplierTierGroupDto, any>({
                path: `/admin/v1/activity-points-multiplier-tier-groups/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-points-multiplier-tier-group-controller
         * @name ActivityPointsMultiplierTierGroupControllerDelete
         * @request DELETE:/admin/v1/activity-points-multiplier-tier-groups/{id}
         * @secure
         */
        activityPointsMultiplierTierGroupControllerDelete: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activity-points-multiplier-tier-groups/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-flag-controller
         * @name ActivityFlagControllerGetActivityFlagById
         * @request GET:/admin/v1/activity-flags/{id}
         * @secure
         */
        activityFlagControllerGetActivityFlagById: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ActivityFlagDto, any>({
                path: `/admin/v1/activity-flags/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-flag-controller
         * @name ActivityFlagControllerUpdateActivityFlag
         * @request PUT:/admin/v1/activity-flags/{id}
         * @secure
         */
        activityFlagControllerUpdateActivityFlag: (
            id: number,
            data: ActivityFlagDto,
            params: RequestParams = {}
        ) =>
            this.request<ActivityFlagDto, any>({
                path: `/admin/v1/activity-flags/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-support-controller
         * @name GoalSupportControllerCreateCommunityDailyGoalV2
         * @request POST:/admin/v2/community-goals
         * @secure
         */
        goalSupportControllerCreateCommunityDailyGoalV2: (
            data: CommunityDailyGoalRequestV2Dto,
            params: RequestParams = {}
        ) =>
            this.request<GoalDto, any>({
                path: `/admin/v2/community-goals`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-support-controller
         * @name WorkoutSupportControllerVerify
         * @request POST:/admin/v1/workouts/{id}/verifications
         * @secure
         */
        workoutSupportControllerVerify: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/workouts/${id}/verifications`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-type-rule-controller
         * @name WorkoutTypeRuleControllerGetPage
         * @request GET:/admin/v1/workout-type-rules
         * @secure
         */
        workoutTypeRuleControllerGetPage: (
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageWorkoutTypeRuleDto, any>({
                path: `/admin/v1/workout-type-rules`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-type-rule-controller
         * @name WorkoutTypeRuleControllerCreate
         * @request POST:/admin/v1/workout-type-rules
         * @secure
         */
        workoutTypeRuleControllerCreate: (
            data: WorkoutTypeRuleCreateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<WorkoutTypeRuleDto, any>({
                path: `/admin/v1/workout-type-rules`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * @description Triggers a full recalculation of goal progress from existing activities for each day in the given range. Use when activities were missed during initial goal assignment (e.g. due to event timing). Defaults to today if no range is specified.
         *
         * @tags User Goal Admin
         * @name UserGoalAdminControllerRecalculateGoalProgress
         * @summary Recalculate goal progress
         * @request POST:/admin/v1/users/{userId}/goals/{assignmentId}/recalculate
         * @secure
         */
        userGoalAdminControllerRecalculateGoalProgress: (
            userId: string,
            assignmentId: number,
            query?: {
                /**
                 * Start date of the range to recalculate (inclusive, defaults to today)
                 * @format date
                 */
                dayFrom?: string;
                /**
                 * End date of the range to recalculate (inclusive, defaults to dayFrom)
                 * @format date
                 */
                dayTo?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/users/${userId}/goals/${assignmentId}/recalculate`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerExportUserActivitiesToEvaluatedActivitiesQueue
         * @request POST:/admin/v1/users/{userId}/evaluated-activities-queue-export
         * @secure
         */
        activitySupportControllerExportUserActivitiesToEvaluatedActivitiesQueue:
            (
                userId: string,
                query?: {
                    from?: string;
                    to?: string;
                },
                params: RequestParams = {}
            ) =>
                this.request<void, any>({
                    path: `/admin/v1/users/${userId}/evaluated-activities-queue-export`,
                    method: 'POST',
                    query: query,
                    secure: true,
                    ...params
                }),

        /**
         * No description
         *
         * @tags user-flag-controller
         * @name UserFlagControllerGetUserFlags
         * @request GET:/admin/v1/user-flags
         * @secure
         */
        userFlagControllerGetUserFlags: (
            query?: {
                userId?: string;
                createdBy?: string;
                status?: WorkoutFlagStatus;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageUserFlagDto, any>({
                path: `/admin/v1/user-flags`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-flag-controller
         * @name UserFlagControllerCreateUserFlag
         * @request POST:/admin/v1/user-flags
         * @secure
         */
        userFlagControllerCreateUserFlag: (
            data: UserFlagDto,
            params: RequestParams = {}
        ) =>
            this.request<UserFlagDto, any>({
                path: `/admin/v1/user-flags`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * @description Revokes a user badge by setting its status to REVOKED and recording who revoked it
         *
         * @tags User Badge V2 Admin
         * @name UserBadgeV2AdminControllerRevokeUserBadge
         * @summary Revoke a user badge
         * @request POST:/admin/v1/user-badges/{id}/revoke
         * @secure
         */
        userBadgeV2AdminControllerRevokeUserBadge: (
            id: number,
            data: UserBadgeV2RevokeRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<UserBadgeV2AdminDetailDto, any>({
                path: `/admin/v1/user-badges/${id}/revoke`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags job-controller
         * @name JobControllerTriggerJob
         * @request POST:/admin/v1/jobs/{job}
         * @secure
         */
        jobControllerTriggerJob: (job: Job, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/admin/v1/jobs/${job}`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-support-controller
         * @name GoalSupportControllerCreateRewardConfig
         * @request POST:/admin/v1/goals/{goalId}/reward-configs
         * @secure
         */
        goalSupportControllerCreateRewardConfig: (
            goalId: number,
            data: RewardConfigDto,
            params: RequestParams = {}
        ) =>
            this.request<RewardConfigDto, any>({
                path: `/admin/v1/goals/${goalId}/reward-configs`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-support-controller
         * @name GoalSupportControllerResendGoalReachedEvents
         * @request POST:/admin/v1/goal-reached-events
         * @secure
         */
        goalSupportControllerResendGoalReachedEvents: (
            data: GoalReachedEventResendRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/goal-reached-events`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-progress-support-controller
         * @name GoalProgressSupportControllerRefreshStreak
         * @request POST:/admin/v1/goal-progresses/{goalProgressId}/streak-refresh
         * @secure
         */
        goalProgressSupportControllerRefreshStreak: (
            goalProgressId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/goal-progresses/${goalProgressId}/streak-refresh`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-progress-support-controller
         * @name GoalProgressSupportControllerRefreshRewards
         * @request POST:/admin/v1/goal-progresses/{goalProgressId}/rewards-refresh
         * @secure
         */
        goalProgressSupportControllerRefreshRewards: (
            goalProgressId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/goal-progresses/${goalProgressId}/rewards-refresh`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-progress-support-controller
         * @name GoalProgressSupportControllerRefreshProgress
         * @request POST:/admin/v1/goal-progresses/{goalProgressId}/refresh
         * @secure
         */
        goalProgressSupportControllerRefreshProgress: (
            goalProgressId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/goal-progresses/${goalProgressId}/refresh`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-progress-support-controller
         * @name GoalProgressSupportControllerInitProgresses
         * @request POST:/admin/v1/goal-progress-init
         * @secure
         */
        goalProgressSupportControllerInitProgresses: (
            data: GoalProgressInitRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/goal-progress-init`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-assignment-support-controller
         * @name GoalAssignmentSupportControllerAssignGoal
         * @request POST:/admin/v1/goal-assignments
         * @secure
         */
        goalAssignmentSupportControllerAssignGoal: (
            data: GoalAssignmentRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<GoalAssignmentDto, any>({
                path: `/admin/v1/goal-assignments`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-assignment-support-controller
         * @name GoalAssignmentSupportControllerFixFamilyGoalAssignments
         * @request POST:/admin/v1/fix-family-goal-assignments
         * @secure
         */
        goalAssignmentSupportControllerFixFamilyGoalAssignments: (
            data: FixFamilyAssignmentRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/fix-family-goal-assignments`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags cdn-object-support-controller
         * @name CdnObjectSupportControllerUpload
         * @request POST:/admin/v1/files
         * @secure
         */
        cdnObjectSupportControllerUpload: (
            query: {
                type: CdnObjectType;
            },
            data: {
                /** @format binary */
                file: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<CdnObjectDto, any>({
                path: `/admin/v1/files`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags facility-visit-support-controller
         * @name FacilityVisitSupportControllerGetPage
         * @request GET:/admin/v1/facility-visits
         * @secure
         */
        facilityVisitSupportControllerGetPage: (
            query?: {
                visitType?: FacilityVisitType;
                rejected?: boolean;
                verificationRequired?: boolean;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageFacilityVisitDto, any>({
                path: `/admin/v1/facility-visits`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags facility-visit-support-controller
         * @name FacilityVisitSupportControllerCreate
         * @request POST:/admin/v1/facility-visits
         * @secure
         */
        facilityVisitSupportControllerCreate: (
            data: FacilityVisitEvent,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/facility-visits`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags facility-visit-support-controller
         * @name FacilityVisitSupportControllerVerify
         * @request POST:/admin/v1/facility-visits/{id}/verifications
         * @secure
         */
        facilityVisitSupportControllerVerify: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/facility-visits/${id}/verifications`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerExportActivitiesToEvaluatedActivitiesQueue
         * @request POST:/admin/v1/evaluated-activities-queue-export
         * @secure
         */
        activitySupportControllerExportActivitiesToEvaluatedActivitiesQueue: (
            query: {
                timestampFrom: string;
                timestampTo: string;
                sourceCreatedDateFrom: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/evaluated-activities-queue-export`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerExportActivitiesToEvaluatedActivitiesQueue1
         * @request POST:/admin/v1/evaluated-activities-queue-export/by-ids
         * @secure
         */
        activitySupportControllerExportActivitiesToEvaluatedActivitiesQueue1: (
            query: {
                activityIds: number[];
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/evaluated-activities-queue-export/by-ids`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags composite-point-definition-controller
         * @name CompositePointDefinitionControllerGetByCommunityId
         * @request GET:/admin/v1/composite-point-definitions
         * @secure
         */
        compositePointDefinitionControllerGetByCommunityId: (
            query: {
                /** @format int64 */
                communityId: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<CompositePointDefinitionDto[], any>({
                path: `/admin/v1/composite-point-definitions`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags composite-point-definition-controller
         * @name CompositePointDefinitionControllerCreate
         * @request POST:/admin/v1/composite-point-definitions
         * @secure
         */
        compositePointDefinitionControllerCreate: (
            data: CreateCompositePointDefinitionRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CompositePointDefinitionDto, any>({
                path: `/admin/v1/composite-point-definitions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-goal-admin-controller
         * @name CommunityGoalAdminControllerCreateCommunityGoal
         * @request POST:/admin/v1/community-goals
         * @secure
         */
        communityGoalAdminControllerCreateCommunityGoal: (
            data: CommunityDailyGoalRequestV3Dto,
            params: RequestParams = {}
        ) =>
            this.request<GoalDto, any>({
                path: `/admin/v1/community-goals`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-support-controller
         * @name GoalSupportControllerCreateCommunityDailyGoal
         * @request POST:/admin/v1/community-daily-goals
         * @secure
         */
        goalSupportControllerCreateCommunityDailyGoal: (
            data: CommunityDailyGoalRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<GoalDto, any>({
                path: `/admin/v1/community-daily-goals`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-calculated-metric-definition-controller
         * @name WorkoutCalculatedMetricDefinitionControllerGetAll
         * @request GET:/admin/v1/calculated-metric-definitions
         * @secure
         */
        workoutCalculatedMetricDefinitionControllerGetAll: (
            params: RequestParams = {}
        ) =>
            this.request<WorkoutCalculatedMetricDefinitionDto[], any>({
                path: `/admin/v1/calculated-metric-definitions`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-calculated-metric-definition-controller
         * @name WorkoutCalculatedMetricDefinitionControllerCreate
         * @request POST:/admin/v1/calculated-metric-definitions
         * @secure
         */
        workoutCalculatedMetricDefinitionControllerCreate: (
            data: CreateWorkoutCalculatedMetricDefinitionRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<WorkoutCalculatedMetricDefinitionDto, any>({
                path: `/admin/v1/calculated-metric-definitions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-type-admin-controller
         * @name BadgeTypeAdminControllerGetTypes
         * @request GET:/admin/v1/badges/types
         * @secure
         */
        badgeTypeAdminControllerGetTypes: (
            query?: {
                /** @format int64 */
                categoryId?: number;
                /** @format int64 */
                ownerCommunityId?: number;
                /**
                 * Zero-based page index (0..N)
                 * @min 0
                 * @default 0
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 * @min 1
                 * @default 50
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 * @default ["sortOrder,ASC"]
                 */
                sort?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<PageBadgeTypeAdminDto, any>({
                path: `/admin/v1/badges/types`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-type-admin-controller
         * @name BadgeTypeAdminControllerCreateType
         * @request POST:/admin/v1/badges/types
         * @secure
         */
        badgeTypeAdminControllerCreateType: (
            data: BadgeTypeCreateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<BadgeTypeAdminDto, any>({
                path: `/admin/v1/badges/types`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-seed-support-controller
         * @name BadgeSeedSupportControllerTriggerBadgeSeed
         * @request POST:/admin/v1/badges/seed
         * @secure
         */
        badgeSeedSupportControllerTriggerBadgeSeed: (
            query?: {
                configPath?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/badges/seed`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-level-admin-controller
         * @name BadgeLevelAdminControllerGetLevels
         * @request GET:/admin/v1/badges/levels
         * @secure
         */
        badgeLevelAdminControllerGetLevels: (
            query?: {
                /** @format int64 */
                badgeTypeId?: number;
                /**
                 * Zero-based page index (0..N)
                 * @min 0
                 * @default 0
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 * @min 1
                 * @default 50
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 * @default ["levelIndex,ASC"]
                 */
                sort?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<PageBadgeLevelAdminDto, any>({
                path: `/admin/v1/badges/levels`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-level-admin-controller
         * @name BadgeLevelAdminControllerCreateLevel
         * @request POST:/admin/v1/badges/levels
         * @secure
         */
        badgeLevelAdminControllerCreateLevel: (
            data: BadgeLevelCreateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<BadgeLevelAdminDto, any>({
                path: `/admin/v1/badges/levels`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-image-admin-controller
         * @name BadgeImageAdminControllerUploadBadgeImage
         * @request POST:/admin/v1/badges/images
         * @secure
         */
        badgeImageAdminControllerUploadBadgeImage: (
            data: {
                /** @format binary */
                file: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<CdnObjectDto, any>({
                path: `/admin/v1/badges/images`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-type-admin-controller
         * @name BadgeTypeAdminControllerCreateChallengeBadge
         * @request POST:/admin/v1/badges/challenge-badge
         * @secure
         */
        badgeTypeAdminControllerCreateChallengeBadge: (
            data: ChallengeBadgeCreateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<BadgeTypeAdminDto, any>({
                path: `/admin/v1/badges/challenge-badge`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-category-admin-controller
         * @name BadgeCategoryAdminControllerGetCategories
         * @request GET:/admin/v1/badges/categories
         * @secure
         */
        badgeCategoryAdminControllerGetCategories: (
            query?: {
                /**
                 * Zero-based page index (0..N)
                 * @min 0
                 * @default 0
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 * @min 1
                 * @default 50
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 * @default ["sortOrder,ASC"]
                 */
                sort?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<PageBadgeCategoryAdminDto, any>({
                path: `/admin/v1/badges/categories`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-category-admin-controller
         * @name BadgeCategoryAdminControllerCreateCategory
         * @request POST:/admin/v1/badges/categories
         * @secure
         */
        badgeCategoryAdminControllerCreateCategory: (
            data: BadgeCategoryCreateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<BadgeCategoryAdminDto, any>({
                path: `/admin/v1/badges/categories`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-badge-assignment-admin-controller
         * @name UserBadgeAssignmentAdminControllerAssignBadges
         * @request POST:/admin/v1/badges/assign
         * @secure
         */
        userBadgeAssignmentAdminControllerAssignBadges: (
            data: UserBadgeAssignmentRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<UserBadgeAssignmentResponseDto, any>({
                path: `/admin/v1/badges/assign`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-badge-assignment-admin-controller
         * @name UserBadgeAssignmentAdminControllerAssignGoalsFromBadgeTypes
         * @request POST:/admin/v1/badges/assign-goals
         * @secure
         */
        userBadgeAssignmentAdminControllerAssignGoalsFromBadgeTypes: (
            data: GoalAssignmentFromBadgeRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<GoalAssignmentFromBadgeResponseDto, any>({
                path: `/admin/v1/badges/assign-goals`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-source-admin-controller
         * @name ActivitySourceAdminControllerGetActivitySources
         * @request GET:/admin/v1/activity-sources
         * @secure
         */
        activitySourceAdminControllerGetActivitySources: (
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageActivitySourceDto, any>({
                path: `/admin/v1/activity-sources`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-source-admin-controller
         * @name ActivitySourceAdminControllerCreateActivitySource
         * @request POST:/admin/v1/activity-sources
         * @secure
         */
        activitySourceAdminControllerCreateActivitySource: (
            data: ActivitySourceDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activity-sources`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-points-multiplier-tier-group-controller
         * @name ActivityPointsMultiplierTierGroupControllerGetPage
         * @request GET:/admin/v1/activity-points-multiplier-tier-groups
         * @secure
         */
        activityPointsMultiplierTierGroupControllerGetPage: (
            query?: {
                activityType?: ActivityType;
                workoutCategory?: WorkoutCategory;
                workoutType?: WorkoutTypeV2;
                recordingMethod?: WorkoutRecordingMethod;
                requiresAverageSpeed?: boolean;
                requiresCaloriesPerMinute?: boolean;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageActivityPointsMultiplierTierGroupDto, any>({
                path: `/admin/v1/activity-points-multiplier-tier-groups`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-points-multiplier-tier-group-controller
         * @name ActivityPointsMultiplierTierGroupControllerCreate
         * @request POST:/admin/v1/activity-points-multiplier-tier-groups
         * @secure
         */
        activityPointsMultiplierTierGroupControllerCreate: (
            data: ActivityPointsMultiplierTierGroupCreateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ActivityPointsMultiplierTierGroupDto, any>({
                path: `/admin/v1/activity-points-multiplier-tier-groups`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerExportActivityPointTransactionsToQueue
         * @request POST:/admin/v1/activity-point-transaction-queue-export
         * @secure
         */
        activitySupportControllerExportActivityPointTransactionsToQueue: (
            data: ActivityPointTransactionExportRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activity-point-transaction-queue-export`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-flag-controller
         * @name ActivityFlagControllerGetActivityFlags
         * @request GET:/admin/v1/activity-flags
         * @secure
         */
        activityFlagControllerGetActivityFlags: (
            query?: {
                /** @format int64 */
                activityId?: number;
                userId?: string;
                status?: WorkoutFlagStatus;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageActivityFlagDto, any>({
                path: `/admin/v1/activity-flags`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-flag-controller
         * @name ActivityFlagControllerCreateActivityFlag
         * @request POST:/admin/v1/activity-flags
         * @secure
         */
        activityFlagControllerCreateActivityFlag: (
            data: ActivityFlagDto,
            params: RequestParams = {}
        ) =>
            this.request<ActivityFlagCreateResponseDto, any>({
                path: `/admin/v1/activity-flags`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerRejectActivity
         * @request POST:/admin/v1/activities/{id}/rejections
         * @secure
         */
        activitySupportControllerRejectActivity: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activities/${id}/rejections`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerDeleteActivityRejection
         * @request DELETE:/admin/v1/activities/{id}/rejections
         * @secure
         */
        activitySupportControllerDeleteActivityRejection: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activities/${id}/rejections`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerBackfillActivity
         * @request POST:/admin/v1/activities/{id}/backfills
         * @secure
         */
        activitySupportControllerBackfillActivity: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ActivityBackfillDto, any>({
                path: `/admin/v1/activities/${id}/backfills`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerCreateWorkoutActivity
         * @request POST:/admin/v1/activities/workout
         * @secure
         */
        activitySupportControllerCreateWorkoutActivity: (
            data: WorkoutEvent,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activities/workout`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerCreateStepsActivity
         * @request POST:/admin/v1/activities/steps
         * @secure
         */
        activitySupportControllerCreateStepsActivity: (
            data: DailyStepsEvent,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activities/steps`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerRejectActivities
         * @request POST:/admin/v1/activities/rejections
         * @secure
         */
        activitySupportControllerRejectActivities: (
            data: ActivityRejectionRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activities/rejections`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerCreateFacilityVisitActivity
         * @request POST:/admin/v1/activities/facility-visit
         * @deprecated
         * @secure
         */
        activitySupportControllerCreateFacilityVisitActivity: (
            data: FacilityVisitEvent,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/activities/facility-visit`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-support-controller
         * @name WorkoutSupportControllerGetPage
         * @request GET:/admin/v1/workouts
         * @secure
         */
        workoutSupportControllerGetPage: (
            query?: {
                rejected?: boolean;
                verificationRequired?: boolean;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageWorkoutReviewDto, any>({
                path: `/admin/v1/workouts`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-support-controller
         * @name WorkoutSupportControllerGet
         * @request GET:/admin/v1/workouts/{id}
         * @secure
         */
        workoutSupportControllerGet: (id: number, params: RequestParams = {}) =>
            this.request<WorkoutReviewDetailsDto, any>({
                path: `/admin/v1/workouts/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-type-mapping-admin-controller
         * @name WorkoutTypeMappingAdminControllerExport
         * @request GET:/admin/v1/workout-type-mappings/export
         * @secure
         */
        workoutTypeMappingAdminControllerExport: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/admin/v1/workout-type-mappings/export`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags workout-category-admin-controller
         * @name WorkoutCategoryAdminControllerGetWorkoutCategories
         * @request GET:/admin/v1/workout-categories
         * @secure
         */
        workoutCategoryAdminControllerGetWorkoutCategories: (
            params: RequestParams = {}
        ) =>
            this.request<WorkoutCategoryWithTypesDto[], any>({
                path: `/admin/v1/workout-categories`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * @description Returns a paginated list of goal assignments for a specific user with optional badge linkage filtering
         *
         * @tags User Goal Admin
         * @name UserGoalAdminControllerGetUserGoalAssignments
         * @summary Get user goal assignments
         * @request GET:/admin/v1/users/{userId}/goals
         * @secure
         */
        userGoalAdminControllerGetUserGoalAssignments: (
            userId: string,
            query?: {
                /** Filter by badge linkage: true = only goals with linked badges, false = only goals without linked badges, null = all goals */
                hasBadge?: boolean;
                /**
                 * Zero-based page index (0..N)
                 * @min 0
                 * @default 0
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 * @min 1
                 * @default 20
                 */
                size?: number;
                /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<PageUserGoalAssignmentAdminDto, any>({
                path: `/admin/v1/users/${userId}/goals`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * @description Returns detailed information about a specific goal assignment
         *
         * @tags User Goal Admin
         * @name UserGoalAdminControllerGetUserGoalAssignment
         * @summary Get user goal assignment detail
         * @request GET:/admin/v1/users/{userId}/goals/{assignmentId}
         * @secure
         */
        userGoalAdminControllerGetUserGoalAssignment: (
            userId: string,
            assignmentId: number,
            params: RequestParams = {}
        ) =>
            this.request<UserGoalAssignmentAdminDto, any>({
                path: `/admin/v1/users/${userId}/goals/${assignmentId}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * @description Soft deletes a goal assignment for the specified user
         *
         * @tags User Goal Admin
         * @name UserGoalAdminControllerDeleteUserGoalAssignment
         * @summary Remove user goal assignment
         * @request DELETE:/admin/v1/users/{userId}/goals/{assignmentId}
         * @secure
         */
        userGoalAdminControllerDeleteUserGoalAssignment: (
            userId: string,
            assignmentId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/users/${userId}/goals/${assignmentId}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * @description Returns a paginated list of badges earned by a specific user, ordered by earned date descending
         *
         * @tags User Badge V2 Admin
         * @name UserBadgeV2AdminControllerGetUserBadgesByUserId
         * @summary Get user badges by user ID
         * @request GET:/admin/v1/users/{userId}/badges
         * @secure
         */
        userBadgeV2AdminControllerGetUserBadgesByUserId: (
            userId: string,
            query?: {
                /**
                 * Zero-based page index (0..N)
                 * @min 0
                 * @default 0
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 * @min 1
                 * @default 20
                 */
                size?: number;
                /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<PageUserBadgeV2AdminDto, any>({
                path: `/admin/v1/users/${userId}/badges`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * @description Returns a paginated list of all user badges with badge level, type, and category information
         *
         * @tags User Badge V2 Admin
         * @name UserBadgeV2AdminControllerGetAllUserBadges
         * @summary Get all user badges
         * @request GET:/admin/v1/user-badges
         * @secure
         */
        userBadgeV2AdminControllerGetAllUserBadges: (
            query?: {
                /**
                 * Zero-based page index (0..N)
                 * @min 0
                 * @default 0
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 * @min 1
                 * @default 20
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 * @default ["earnedAt,ASC"]
                 */
                sort?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<PageUserBadgeV2AdminDto, any>({
                path: `/admin/v1/user-badges`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * @description Returns detailed information about a specific user badge
         *
         * @tags User Badge V2 Admin
         * @name UserBadgeV2AdminControllerGetUserBadgeById
         * @summary Get user badge by ID
         * @request GET:/admin/v1/user-badges/{id}
         * @secure
         */
        userBadgeV2AdminControllerGetUserBadgeById: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<UserBadgeV2AdminDetailDto, any>({
                path: `/admin/v1/user-badges/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * @description Soft deletes a user badge. The badge will no longer be visible but can be restored if needed.
         *
         * @tags User Badge V2 Admin
         * @name UserBadgeV2AdminControllerDeleteUserBadge
         * @summary Delete a user badge
         * @request DELETE:/admin/v1/user-badges/{id}
         * @secure
         */
        userBadgeV2AdminControllerDeleteUserBadge: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/user-badges/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-goal-admin-controller
         * @name CommunityGoalAdminControllerGetGoals
         * @request GET:/admin/v1/goals
         * @secure
         */
        communityGoalAdminControllerGetGoals: (
            query?: {
                type?: RecurrenceType;
                /** @format int64 */
                communityId?: number;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageGoalDto, any>({
                path: `/admin/v1/goals`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-progress-support-controller
         * @name GoalProgressSupportControllerGetGoalProgresses
         * @request GET:/admin/v1/goal-assignments/{goalAssignmentId}/goal-progresses
         * @secure
         */
        goalProgressSupportControllerGetGoalProgresses: (
            goalAssignmentId: number,
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageGoalProgressDto, any>({
                path: `/admin/v1/goal-assignments/${goalAssignmentId}/goal-progresses`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags fraud-monitor-support-controller
         * @name FraudMonitorSupportControllerGetActivities
         * @request GET:/admin/v1/fraud-monitor/activity-overviews
         * @secure
         */
        fraudMonitorSupportControllerGetActivities: (
            query: {
                /** @minLength 1 */
                userId: string;
                /** @format date */
                day: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<ActivityOverviewSupportDto, any>({
                path: `/admin/v1/fraud-monitor/activity-overviews`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags facility-visit-support-controller
         * @name FacilityVisitSupportControllerGet
         * @request GET:/admin/v1/facility-visits/{id}
         * @secure
         */
        facilityVisitSupportControllerGet: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<FacilityVisitDetailsDto, any>({
                path: `/admin/v1/facility-visits/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * @description Returns a paginated list of users who have earned any level of a specific badge type
         *
         * @tags User Badge V2 Admin
         * @name UserBadgeV2AdminControllerGetUserBadgesByBadgeTypeId
         * @summary Get user badges by badge type ID
         * @request GET:/admin/v1/badges/types/{badgeTypeId}/user-badges
         * @secure
         */
        userBadgeV2AdminControllerGetUserBadgesByBadgeTypeId: (
            badgeTypeId: number,
            query?: {
                /**
                 * Zero-based page index (0..N)
                 * @min 0
                 * @default 0
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 * @min 1
                 * @default 20
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 * @default ["earnedAt,ASC"]
                 */
                sort?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<PageUserBadgeV2AdminDto, any>({
                path: `/admin/v1/badges/types/${badgeTypeId}/user-badges`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * @description Returns a paginated list of users who have earned a specific badge level
         *
         * @tags User Badge V2 Admin
         * @name UserBadgeV2AdminControllerGetUserBadgesByBadgeLevelId
         * @summary Get user badges by badge level ID
         * @request GET:/admin/v1/badges/levels/{badgeLevelId}/user-badges
         * @secure
         */
        userBadgeV2AdminControllerGetUserBadgesByBadgeLevelId: (
            badgeLevelId: number,
            query?: {
                /**
                 * Zero-based page index (0..N)
                 * @min 0
                 * @default 0
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 * @min 1
                 * @default 20
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 * @default ["earnedAt,ASC"]
                 */
                sort?: string[];
            },
            params: RequestParams = {}
        ) =>
            this.request<PageUserBadgeV2AdminDto, any>({
                path: `/admin/v1/badges/levels/${badgeLevelId}/user-badges`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerGetActivityPoints
         * @request GET:/admin/v1/activity-points
         * @secure
         */
        activitySupportControllerGetActivityPoints: (
            query: {
                userId: string;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageActivityPointsDto, any>({
                path: `/admin/v1/activity-points`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerGetActivityPointsSummary
         * @request GET:/admin/v1/activity-points-summary
         * @secure
         */
        activitySupportControllerGetActivityPointsSummary: (
            query: {
                /** @minLength 1 */
                userId: string;
                /** @format date-time */
                timeFrom: string;
                /** @format date-time */
                timeTo?: string;
                activityTypes: ActivityType[];
            },
            params: RequestParams = {}
        ) =>
            this.request<ActivityPointsSummaryDto, any>({
                path: `/admin/v1/activity-points-summary`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerGetActivityPointChanges
         * @request GET:/admin/v1/activity-point-changes
         * @secure
         */
        activitySupportControllerGetActivityPointChanges: (
            query: {
                userId: string;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageActivityPointsChangeDto, any>({
                path: `/admin/v1/activity-point-changes`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerGetActivities
         * @request GET:/admin/v1/activities
         * @secure
         */
        activitySupportControllerGetActivities: (
            query: {
                userId: string;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageActivityDto, any>({
                path: `/admin/v1/activities`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags activity-support-controller
         * @name ActivitySupportControllerGetActivity
         * @request GET:/admin/v1/activities/{id}
         * @secure
         */
        activitySupportControllerGetActivity: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ActivityDetailsSupportDto, any>({
                path: `/admin/v1/activities/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * @description Permanently deletes a user badge from the database. This action cannot be undone.
         *
         * @tags User Badge V2 Admin
         * @name UserBadgeV2AdminControllerHardDeleteUserBadge
         * @summary Permanently delete a user badge
         * @request DELETE:/admin/v1/user-badges/{id}/permanent
         * @secure
         */
        userBadgeV2AdminControllerHardDeleteUserBadge: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/user-badges/${id}/permanent`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags badge-seed-support-controller
         * @name BadgeSeedSupportControllerDeleteAllBadges
         * @request DELETE:/admin/v1/badges/all
         * @secure
         */
        badgeSeedSupportControllerDeleteAllBadges: (
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/admin/v1/badges/all`,
                method: 'DELETE',
                secure: true,
                ...params
            })
    };
}
